const militaryOfficerOptions = ['Officer', 'Enlisted', 'NotApplicable'];

export default militaryOfficerOptions;
